import { FlexBox } from '@airship-platform/jam-web/components';
import { SmallDownArrowIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router';
import ROUTE_PATHS from '../../../routes/paths';

interface QuickAction {
  label: string;
  href?: string;
  to?: string;
  visible?: boolean;
}

interface ScheduleCardActionProps {
  appointmentId: string;
  color: 'softGold' | 'softBlue';
  children: string;
  to?: string;
  quickActions?: QuickAction[];
}

const ScheduleCardAction: React.FC<ScheduleCardActionProps> = ({
  appointmentId,
  color,
  children,
  to,
  quickActions,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const visibleActions = quickActions?.filter(
    (action) => action.visible !== false
  );

  return (
    <FlexBox gap={1}>
      <Button
        size={'large'}
        fullWidth
        component={RouterLink}
        to={to ?? ROUTE_PATHS.SCHEDULE_DETAIL(appointmentId)}
        color={color}
        children={children}
      />
      {visibleActions?.length ? (
        <>
          <IconButton
            color="softGold"
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{ width: 48, height: 48 }}
          >
            <SmallDownArrowIcon />
          </IconButton>
          <Menu
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <FlexBox gap={1} p={2} flexDirection={'column'}>
              <Typography variant="body3">Quick actions</Typography>
              <Divider />
              {visibleActions.map((action) => (
                <MenuItem
                  key={action.label}
                  component={action.href ? Link : RouterLink}
                  {...(action.href ? { href: action.href } : { to: action.to })}
                >
                  {action.label}
                </MenuItem>
              ))}
            </FlexBox>
          </Menu>
        </>
      ) : null}
    </FlexBox>
  );
};

export default ScheduleCardAction;
